/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FxRate,
    FxRateFromJSON,
    FxRateToJSON,
} from '../models/FxRate';
import {
    type FxRateKey,
    FxRateKeyFromJSON,
    FxRateKeyToJSON,
} from '../models/FxRateKey';

export interface CreateFxRateKeyRequest {
    id: string;
    key: string;
    fxRateKey: FxRateKey;
    ignoreDuplicate?: boolean;
}

export interface DeleteFxRateKeyRequest {
    id: string;
    key: string;
}

export interface GetFxRateKeyRequest {
    id: string;
    key: string;
}

export interface GetFxRateKey1Request {
    id: string;
}

export interface GetFxRatesRequest {
    id: string;
    key: string;
}

export interface SetFxRatesRequest {
    id: string;
    key: string;
    fxRate: Array<FxRate>;
}

/**
 * 
 */
export class FxRateApi extends runtime.BaseAPI {

    /**
     * Creates request options for createFxRateKey without sending the request
     */
    async createFxRateKeyRequestOpts(requestParameters: CreateFxRateKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFxRateKey().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling createFxRateKey().'
            );
        }

        if (requestParameters['fxRateKey'] == null) {
            throw new runtime.RequiredError(
                'fxRateKey',
                'Required parameter "fxRateKey" was null or undefined when calling createFxRateKey().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ignoreDuplicate'] != null) {
            queryParameters['ignoreDuplicate'] = requestParameters['ignoreDuplicate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxRateKeyToJSON(requestParameters['fxRateKey']),
        };
    }

    /**
     */
    async createFxRateKeyRaw(requestParameters: CreateFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxRateKey>> {
        const requestOptions = await this.createFxRateKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxRateKeyFromJSON(jsonValue));
    }

    /**
     */
    async createFxRateKey(requestParameters: CreateFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxRateKey> {
        const response = await this.createFxRateKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteFxRateKey without sending the request
     */
    async deleteFxRateKeyRequestOpts(requestParameters: DeleteFxRateKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFxRateKey().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteFxRateKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteFxRateKeyRaw(requestParameters: DeleteFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteFxRateKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteFxRateKey(requestParameters: DeleteFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFxRateKeyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getFxRateKey without sending the request
     */
    async getFxRateKeyRequestOpts(requestParameters: GetFxRateKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFxRateKey().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getFxRateKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getFxRateKeyRaw(requestParameters: GetFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxRateKey>> {
        const requestOptions = await this.getFxRateKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxRateKeyFromJSON(jsonValue));
    }

    /**
     */
    async getFxRateKey(requestParameters: GetFxRateKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxRateKey> {
        const response = await this.getFxRateKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFxRateKey1 without sending the request
     */
    async getFxRateKey1RequestOpts(requestParameters: GetFxRateKey1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFxRateKey1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getFxRateKey1Raw(requestParameters: GetFxRateKey1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FxRateKey>>> {
        const requestOptions = await this.getFxRateKey1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxRateKeyFromJSON));
    }

    /**
     */
    async getFxRateKey1(requestParameters: GetFxRateKey1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FxRateKey>> {
        const response = await this.getFxRateKey1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFxRates without sending the request
     */
    async getFxRatesRequestOpts(requestParameters: GetFxRatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFxRates().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getFxRates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate/{key}/rates`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getFxRatesRaw(requestParameters: GetFxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FxRate>>> {
        const requestOptions = await this.getFxRatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxRateFromJSON));
    }

    /**
     */
    async getFxRates(requestParameters: GetFxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FxRate>> {
        const response = await this.getFxRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setFxRates without sending the request
     */
    async setFxRatesRequestOpts(requestParameters: SetFxRatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setFxRates().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling setFxRates().'
            );
        }

        if (requestParameters['fxRate'] == null) {
            throw new runtime.RequiredError(
                'fxRate',
                'Required parameter "fxRate" was null or undefined when calling setFxRates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/fx-rate/{key}/rates`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['fxRate']!.map(FxRateToJSON),
        };
    }

    /**
     */
    async setFxRatesRaw(requestParameters: SetFxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FxRate>>> {
        const requestOptions = await this.setFxRatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxRateFromJSON));
    }

    /**
     */
    async setFxRates(requestParameters: SetFxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FxRate>> {
        const response = await this.setFxRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
